/**
 * @author Björn Schmitt
 */
!function ($) {

	var TabDrop = function (element, options) {

		this.options = options;
		this.element = $(element);
		this.menu = $('<li class="dropdown tabdrop force-hide"><a href="#" class="dropdown-toggle dropdown-link noajax" data-toggle="dropdown"><span class="dropdown-menu-text">' + this.options.text + '</span><b class="caret"></b><span class="hamburger" id="hamburgerIcon"><span class="hamburger-slices"></span><span class="hamburger-slices"></span><span class="hamburger-slices"></span></span></a><span class="navborder"></span><ul class="dropdown-menu"></ul></li>');
		this.element.append(this.menu);

		var that = this;

		// manual start trigger with $(...).data('tabdrop').start()
		if (this.options.startEvent != 'manual') {

			if (this.options.startEvent) {

				// start by event registered on document, $(document).trigger('name')
				$(document).on(this.options.startEvent, function () {
					that.start();
				});

			} else {

				// default, start after timeout
				setTimeout(function () {
					that.start();
				}, this.options.startTimeout);

			}

		}

		// also on resize
		$(window).resize(function () {
			that.update();
		});

	};

	TabDrop.prototype = {

		constructor: TabDrop,

		start: function () {

			this.run();

		},

		update: function () {

			var origin = this,
				elements = $(origin.element).find('>li'),
				count = elements.length;

			elements.each(function () {

				$(this).addClass('force-hide');

				if (!--count) {

					origin.run();

				}

			});

		},

		run: function () {

			var origin = this,
				nav = $(this.element),
				navWidth = origin.options.windowWidth ? $(window).width() : nav.width();

			var options = [],
				elements = nav.find('>li').not('.tabdrop'),
				menu = nav.find('>li.tabdrop'),
				menuWidth;

			// max possible nav width
			navWidth = origin.options.windowWidth ? $(window).width() : nav.width();

			// reduce by defined containers
			if (origin.options.reduceWidthContainer.length > 0) {
				$.each(origin.options.reduceWidthContainer, function (key, value) {
					if ($(value).length > 0) {
						navWidth -= $(value).outerWidth(true);
                        //console.log(value);
                        //console.log('outerWidth',$(value).outerWidth(true));
                        //console.log('css width',$(value).css('width'));
					}
				});
			}

			// reduce by menu
			menu.addClass('visibility-hidden').removeClass('force-hide');
			menuWidth = menu.outerWidth(true);
			menu.addClass('force-hide').removeClass('visibility-hidden');
			navWidth -= menuWidth;

			// additional values
			navWidth -= origin.options.reduceWidth;

			// reduce by nav elements until width is exceeded
			var elementsCount = elements.length;
			elements.each(function () {

				var item = $(this);

				item.addClass('visibility-hidden').removeClass('force-hide');

				navWidth -= item.outerWidth(true);

				if (navWidth <= 0) {

					options.push(item.clone().removeClass('visibility-hidden'));
					item.addClass('force-hide').removeClass('visibility-hidden');

				} else {

					item.removeClass('visibility-hidden');

				}

				if (!--elementsCount) {

					if (options.length > 0) {

						menu.find('.text').html((elements.length == options.length ? origin.options.singleText : origin.options.text));
						menu.find('ul').empty().append(options);
						menu.removeClass('force-hide');

						if (menu.find('.active').length > 0) {

							menu.addClass('active');

						} else {

							menu.removeClass('active');

						}

					} else {

						menu.addClass('force-hide');

					}

				}

			});

            // calculate nav width

		}
	};

	// return access all methods with $(...).data('tabdrop')
	$.fn.tabdrop = function (option) {

		return this.each(function () {

			var $this = $(this),
				data = $this.data('tabdrop'),
				options = typeof option === 'object' && option;

			if (!data) {
				$this.data('tabdrop', (data = new TabDrop(this, $.extend({}, $.fn.tabdrop.defaults, options))));
			}

			if (typeof option == 'string') {
				data[option]();
			}

		})
	};

	// defaults
	$.fn.tabdrop.defaults = {
		text: '<span class="glyphicon glyphicon-align-justify"></span>',
		singleText: '<span class="glyphicon glyphicon-align-justify"></span>',
		windowWidth: true,
		reduceWidthContainer: [],
		reduceWidth: 30,
		startEvent: null, // null, manual or event name
		startTimeout: 0
	};

	$.fn.tabdrop.Constructor = TabDrop;

}(window.jQuery);
